import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

export function usePlan(planId: string | undefined) {
  return useQuery({
    queryKey: ["plan", planId],
    queryFn: () => api.getPlan(planId!),
    enabled: !!planId,
    refetchInterval: 15_000,
  });
}
